import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { getPageByOrder, totalPages } from '../../data/pages';
interface PageNavProps {
  currentOrder: number;
}
export function PageNav({
  currentOrder
}: PageNavProps) {
  const prevPage = getPageByOrder(currentOrder - 1);
  const nextPage = getPageByOrder(currentOrder + 1);
  return <nav aria-label="Page sequence" className="border-t border-slate-200 bg-ice" data-id="element-58" data-mp="26ivdhxn9cfks">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 py-10 sm:flex-row sm:justify-between lg:px-10" data-id="element-59" data-mp="2ajnmqqw4qkh2">
        {prevPage ? <Link to={prevPage.path} className="flex items-center gap-2.5 text-sm font-semibold text-navy transition-colors duration-150 hover:text-brandgreen" data-id="element-60" data-mp="2fjjsaukh6jyq">
            <ArrowLeftIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-61" data-mp="l6anhg2vjmmt" />
            <span data-id="element-62" data-mp="q3amx857xr4y">
              <span className="block text-[11px] font-medium uppercase tracking-wide text-slate-500" data-id="element-63" data-mp="q4vgovjpl61r">
                Previous
              </span>
              {prevPage.title}
            </span>
          </Link> : <span aria-hidden="true" data-id="element-64" data-mp="bh28okt8lhat" />}

        <p className="order-first text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 sm:order-none" data-id="element-65" data-mp="6jah5rwi7x75">
          Page {currentOrder} of {totalPages}
        </p>

        {nextPage ? <Link to={nextPage.path} className="flex items-center gap-2.5 text-right text-sm font-semibold text-navy transition-colors duration-150 hover:text-brandgreen" data-id="element-66" data-mp="z8zhs45axv88">
            <span data-id="element-67" data-mp="q79p6uzooq8v">
              <span className="block text-[11px] font-medium uppercase tracking-wide text-slate-500" data-id="element-68" data-mp="q6hv5olqj0kp">Next</span>
              {nextPage.title}
            </span>
            <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-69" data-mp="3aytgdxxlevu1" />
          </Link> : <span aria-hidden="true" data-id="element-70" data-mp="35yxmwsmiumsq" />}
      </div>
    </nav>;
}